<template>
    <a-layout
      :style="{
        minHeight: '100vh'
      }"
    >
        <a-layout-content>
            <h1>Archívum</h1>
            <FadePopTransition>
                <router-view
                    class="login-view-card-container "
                >
                </router-view>
            </FadePopTransition>
        </a-layout-content>
    </a-layout>
</template>

<script>
import FadePopTransition from '@/transitions/FadePopTransition.vue';
import store from '@/store/store.js';
import LocalStorage from '@/helpers/localstorage.js';
import { USER_LOGIN } from '@/store/action_types.js';

export default {
    components: {
        FadePopTransition
    },
    beforeRouteEnter (to, from, next) {
        if (!store.getters.getLoggedin) {
            const data = LocalStorage.getUserData();
            if (data) {
                store.dispatch({
                    type: USER_LOGIN,
                    ...data
                })
                next({
                    name: 'app'
                })
            } else {
                next()
            }
        } else {
            next({
                name: 'app'
            })
        }
    }

}
</script>

<style lang="scss" scoped>
    h1 {
        text-transform: uppercase;
        text-align: center;
        margin-top: 5%;
    }

    .login-view-card-container {
        padding-left: 15px;
        padding-right: 15px;
        max-width: 500px;
        margin: auto;
        margin-top: 60px;
    }
</style>
